import Vue from 'vue';
import { marked } from 'marked';

Vue.filter('markdown', function (markdownStr) {
  return marked(markdownStr);
});
